import type { Component } from "solid-js";
import { PaymentMethodModel, PaymentMethodUi } from "~/solidJs/entities/PaymentMethod";
import { useCustomContext } from "~/solidJs/shared";
import { PricingPageParams } from "~/solidJs/shared/models/pageParams";
import { PricingPageContext } from "../methods";

export const SelectPaymentCurrency: Component = () => {
	const store = useCustomContext(PricingPageContext);

	const currencies = PaymentMethodModel.PRICING_PAGE_CURRENCIES.map((currency) => ({
		...currency,
		as: (p: any) => (
			<div
				{...p}
				data-test-method={
					currency.value === PricingPageParams.PaymentCurrency.USD
						? "premium-switch-method-stripe"
						: "premium-switch-method-yoo"
				}
			/>
		)
	}));

	return (
		<div data-test="premium-switch-method">
			<PaymentMethodUi.CurrencySelector
				selectedCurrency={
					currencies.find((item) => item.value === store.getPaymentCurrency()) ||
					currencies[0]
				}
				currencies={currencies}
				onChange={(currency) =>
					store.setPaymentCurrency(currency.value as PricingPageParams.PaymentCurrency)
				}
			/>
		</div>
	);
};
